import React, { useEffect, useState } from "react";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import Table from "react-bootstrap/Table";
import { fetchOrdersWithStatus } from "../../../api/api";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ""; // fallback for (safety(undefined))



interface OrderWithStatus {
  billno: any;
  partyname: string; 
  BillDate: string;
  order_note?: string;
  order_status?: string;
  voice_note?: string;
}

const OrderStatus = () => {
  const { t } = useTranslation();
  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(29, "days"),
    endDate: moment(),
  });

  const [orders, setOrders] = useState<OrderWithStatus[]>([]);
  const navigate = useNavigate();

 const handleApply = (event: any, picker: any) => {
  // Ensure correct start and end dates are set from the selected range
  const start = picker.startDate.clone();
  const end = picker.endDate.clone();

  setDateRange({
    startDate: start,
    endDate: end,
  });
};

  useEffect(() => {
  const loadOrders = async () => {
    try {
      const response = await fetchOrdersWithStatus(dateRange);
      setOrders(response || []);
    } catch (err) {
      console.error("Error loading order status:", err);
    }
  };

  loadOrders();
}, [dateRange]);


  return (
    <div className="page-wrapper">
      <div className="content container-fluid">

        {/* Header */}
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col">
              <h3 className="page-title">{t("orderStatus")}</h3>
            </div>
           <div className="col-auto">
  <DateRangePicker
    onApply={(event: any, picker: any) => {
      // Explicitly update the state from the picker’s selected range
      setDateRange({
        startDate: picker.startDate.clone(),
        endDate: picker.endDate.clone(),
      });
    }}
    initialSettings={{
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
      alwaysShowCalendars: true, // optional, but improves usability
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
    }}
  >
    <button className="btn btn-outline-primary">
      {dateRange.startDate.format("MMM D, YYYY")} -{" "}
      {dateRange.endDate.format("MMM D, YYYY")}
    </button>
  </DateRangePicker>
</div>

          </div>
        </div>

        {/* Table */}
        <div className="card">
          <div className="card-body">
            <Table responsive striped bordered hover className="mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{t("billNo")}</th>
                  <th>{t("partyName")}</th>
                  <th>{t("date")}</th>
                  <th>{t("notes")}</th>
                  
                  <th>{t("status")}</th>
                  <th>{t("voiceNote")}</th>
                </tr>
              </thead>
             <tbody>
                {orders.length > 0 ? (
                  orders.map((order, index) => (
                    <tr
                      key={index}
                      onClick={() => navigate(`/order/order-history/${order.billno}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{index + 1}</td>
                      <td>{order.billno}</td>
                      <td>{order.partyname}</td>
                      <td>{moment(order.BillDate).format("DD/MM/YYYY")}</td>
                      <td>{order.order_note || "-"}</td>
                      <td>
                        <span
                          className={`badge ${
                            order.order_status?.toLowerCase().replace(/\s+/g, "") === "pending"
                              ? "bg-danger text-light"
                              : order.order_status?.toLowerCase().replace(/\s+/g, "") === "customerresponded"
                              ? "bg-warning text-dark"
                              : order.order_status?.toLowerCase().replace(/\s+/g, "") === "responded"
                              ? "bg-warning text-dark"
                              : order.order_status?.toLowerCase().replace(/\s+/g, "") === "invoiceissued"
                              ? ""
                              : order.order_status?.toLowerCase().replace(/\s+/g, "") === "approved"
                              ? ""
                              : order.order_status?.toLowerCase().replace(/\s+/g, "") === "onwork"
                              ? ""
                              : order.order_status?.toLowerCase().replace(/\s+/g, "") === "completed"
                              ? "bg-success text-light"
                              : "bg-light text-dark"
                          }`}
                          style={
                            order.order_status?.toLowerCase().replace(/\s+/g, "") === "onwork"
                              ? { backgroundColor: "#fd7e14", color: "white" }
                              : order.order_status?.toLowerCase().replace(/\s+/g, "") === "invoiceissued"
                              ? { backgroundColor: "#0d6efd", color: "white" }
                              : order.order_status?.toLowerCase().replace(/\s+/g, "") === "approved"
                              ? { backgroundColor: "#66b2ff", color: "white" }
                              : {}
                          }
                        >
                          {order.order_status || "Pending"}
                        </span>
                      </td>

                      {/*Voice Note column */}
                      <td>
                          {order.voice_note ? (
                            <audio
                              controls
                             src={`${API_BASE_URL}${order.voice_note}`}

                              style={{ display: "block", marginTop: "4px", maxWidth: "180px" }}
                            />
                          ) : (
                            "-"
                          )}
                        </td>
                    </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">No orders found</td>
                  </tr>
                )}
              </tbody>

            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderStatus;
